var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiOpen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 739.12 521.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M629.62,0h109.5v521.22h-109.5V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232.14,0h129.94l232.14,521.22h-121.91l-54.75-129.21h-245.28l-54.02,129.21H0L232.14,0ZM384.71,310.25l-89.06-219.73-90.52,219.73h179.58Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiOpen);
export default __webpack_public_path__ + "static/media/ai-open.748d1602d749c264a9ad785d7fec9c0d.svg";
export { ForwardRef as ReactComponent };